export const getErrorMessage = (error) => {
  switch (error) {
    case 'wrong_password':
    case 'user_does_not_exist':
      return 'LOGIN.WRONG_CREDENTIALS';
    default:
      return 'COMMON.DEFAULT_ERROR';
  }
};
